import { useEffect } from 'react';

/**
 * Titre d'onglet et description propres à la page affichée. `index.html` ne
 * déclare que ceux de la plateforme (voir useFavicon.ts pour le même
 * raisonnement côté favicon) — sans ce réglage, chaque article de blog
 * porterait le titre générique de l'application, invisible pour un moteur de
 * recherche qui distingue les pages par leur <title>.
 */
export function useDocumentMeta(title: string | undefined, description?: string): void {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'description';
        document.head.appendChild(meta);
      }
      meta.content = description;
    }
  }, [title, description]);
}
